<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des erreurs de chargements Module Prev</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <ul>
            <li v-for="(error, key) in errors" :key="key">
              {{ error }}
            </li>
          </ul>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>

</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "erreurChargement",
    data() {
      return {
        id: this.$route.params.id,
        errors: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getErrors();
    },
    methods: {
      getErrors() {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/module_prev/rapport/"+this.id)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.errors = response.data.data;
          })
          .catch((error) => {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 4000
            });
          });
      },
    }
  }
</script>
